import { Skel } from "@/components/app/Common";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, get, errMsg } from "@/lib/api";

export function OutcomeEmailDialog({ appId, open, onOpenChange, onSent }) {
  const [p, setP] = useState(null);
  const [edit, setEdit] = useState(false);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    get(`/applications/${appId}/outcome-email`).then((d) => { setP(d); setSubject(d.subject); setBody(d.body); setEdit(false); }).catch((e) => { toast.error(errMsg(e)); onOpenChange(false); });
  }, [open, appId]); // eslint-disable-line react-hooks/exhaustive-deps
  const send = async () => {
    setBusy(true);
    try { await api.post(`/applications/${appId}/outcome-email`, { subject, body }); toast.success("Email queued"); onOpenChange(false); onSent?.(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl rounded-[6px]" data-testid="outcome-email-dialog">
        <DialogHeader><DialogTitle>Preview the outcome email</DialogTitle>
          <DialogDescription>{p ? `To ${p.to || "no email on file"}. Nothing is sent until you press Send.` : <Skel className="h-4 w-64" />}</DialogDescription></DialogHeader>
        {p && (edit ? (
          <div className="space-y-2"><Input value={subject} onChange={(e) => setSubject(e.target.value)} data-testid="outcome-subject-input" />
            <Textarea rows={10} value={body} onChange={(e) => setBody(e.target.value)} className="font-mono text-xs" data-testid="outcome-body-input" />
            <p className="text-xs text-ink-muted">Placeholders like {"{{first_name}}"} and {"{{job_title}}"} are filled in when sending.</p></div>
        ) : (
          <div className="space-y-2"><p className="text-sm font-medium" data-testid="outcome-rendered-subject">{p.rendered_subject}</p>
            <iframe title="Email preview" srcDoc={p.rendered_html} className="h-72 w-full rounded-[5px] border border-line bg-white" data-testid="outcome-preview-frame" /></div>
        ))}
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="outcome-skip-btn">Don't send</Button>
          <Button variant="outline" onClick={() => setEdit(!edit)} data-testid="outcome-edit-btn">{edit ? "Done editing" : "Edit"}</Button>
          <Button onClick={send} disabled={busy || !p?.to} data-testid="outcome-send-btn">Send email</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
